import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Select } from "antd";
import { apiGetSymbolRecommendations } from "api/apiPredictions";
import dayjs from "dayjs";
import GenericCard from "components/UI/GenericCard/GenericCard";

const SymbolCheckup = () => {
  const [symbol, setSymbol] = useState("SOXL");
  const [symbolRecommendations, setSymbolRecommendations] = useState(null);

  const symbolsGroupedInSectored = useSelector(
    (state) => state.main.symbolsGroupedInSectored
  );

  const getSymbolRecommendations = async () => {
    const response = await apiGetSymbolRecommendations(symbol);
    setSymbolRecommendations(response);
  };

  const calculateSignalStrength = (buy, total) => {
    if (+total === 0) return 0;
    return ((+buy / +total) * 100).toFixed(2);
  };

  useEffect(() => {
    if (symbol) {
      getSymbolRecommendations();
    }
  }, [symbol]);

  return (
    <GenericCard
      className="flex-grow"
      title="AI Recommendations"
      disableToggle
      minHeight={85}
    >
      <Select
        placeholder="Enter symbol name"
        showSearch
        dropdownMatchSelectWidth={252}
        options={symbolsGroupedInSectored}
        filterOption={(inputValue, option) =>
          option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        style={{ width: 200 }}
        allowClear
        onSelect={(value) => setSymbol(value)}
        value={symbol}
      />
      <div className="mt-3 min-h-[26px]">
        {symbolRecommendations && (
          <div className="flex flex-col lg:flex-row gap-2 lg:gap-4">
            <div className="flex flex-col">
              {dayjs(symbolRecommendations.latestDate).format("DD/MM/YYYY")}
            </div>
            <div>
              Signal Strength:{" "}
              {calculateSignalStrength(
                symbolRecommendations.buy,
                symbolRecommendations.total_count
              )}
              %
            </div>
            <div className="flex flex-col lg:flex-row gap-2 lg:gap-4">
              <div className={symbolRecommendations.buyMajority ? "green" : ""}>
                Buy: {symbolRecommendations.buy}
              </div>
              <div className={symbolRecommendations.buyMajority ? "" : "red"}>
                No Buy: {symbolRecommendations.noBuy}
              </div>
            </div>
          </div>
        )}
      </div>
    </GenericCard>
  );
};

export default SymbolCheckup;
